import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios/requestInfo";

import { api } from "../../resources/api";
import { IFeedbackData } from "./types";

export const fetchFeedback = createAsyncThunk<string, IFeedbackData>(
  "feedback/fetchFeedback",
  async (data) => {
    try {
      const response = await axiosInstance.post(api.feedback.FEEDBACK, data);
      return response.status === 200 && response.statusText === "OK"
        ? "Success"
        : "Error";
    } catch (error: any) {
      return "Error";
    }
  }
);
